import { render, staticRenderFns } from "./customExpiration.vue?vue&type=template&id=c0bb5fb2&scoped=true&"
import script from "./customExpiration.vue?vue&type=script&lang=js&"
export * from "./customExpiration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0bb5fb2",
  null
  
)

export default component.exports